/* @flow */

import * as React from 'react'

import {
  ControlLabel,
  EditorInput,
  FormInput,
  FormGroup,
  RadioInput,
  SelectInput,
} from '../../../../../infrastructure/components/Formik'

import ProductSelector from '../../../../products/components/ProductSelector'

const WebshopProductCarouselSettings = ({ values }) => {
  return (
    <div>
      <FormGroup>
        <ControlLabel required>Products</ControlLabel>
        <SelectInput
          name="data.products"
          multi
          selectComponent={ProductSelector}
          simpleValue
          testEfficient
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Headline</ControlLabel>
        <EditorInput name="data.headline" height={100} />
      </FormGroup>
      <FormGroup>
        <ControlLabel required>Headline position</ControlLabel>
        <RadioInput
          label="Left"
          id="product-carousel-headline-position-left"
          name="data.headline_position"
          value="left"
        />
        <RadioInput
          label="Center"
          id="product-carousel-headline-position-center"
          name="data.headline_position"
          value="center"
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel required>Product box width (px)</ControlLabel>
        <FormInput name="data.product_width" />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Space between each product (px)</ControlLabel>
        <FormInput name="data.space_between_each_product" />
      </FormGroup>
    </div>
  )
}

export default WebshopProductCarouselSettings
